import React from 'react'
import { Text } from '@amzn/storm-ui'
import { EmptyResultsContainer } from '../../manage_shared.styles'

interface AdvertisersNoResultsBodyProps {
  noResultsBodyLabel: string
  noResultsHeaderLabel: string
}

export const AdvertisersNoResultsBody: React.FunctionComponent<AdvertisersNoResultsBodyProps> = (props: AdvertisersNoResultsBodyProps): JSX.Element => {
  const { noResultsBodyLabel, noResultsHeaderLabel } = props

  return (
    <EmptyResultsContainer>
      <Text textColor="base" type="h3" withMargin>
        {noResultsHeaderLabel}
      </Text>
      <Text textColor="secondary">{noResultsBodyLabel}</Text>
    </EmptyResultsContainer>
  )
}
